<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách TPV</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <!-- <button @click="exportExcel" class="font-medium f12 btn btn-outline-secondary">
          <i class='bx bx-download'></i> Xuất excel
        </button> -->
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.merchantInfo"
              class="form-control f12 hc-37 text-search"
              placeholder="Email Merchant"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.emailSale"
              :options="listUser"
              placeholder="Nhân viên chăm sóc"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.merchantType"
              :options="optionMerchantType"
              placeholder="Loại Merchant"
            />
          </div>
          <div class="form-group">
            <datepicker
              v-model="search.month"
              format="MM/yyyy"
              class="form_fix"
              :minimumView="'month'"
              :maximumView="'month'"
              :language="vi"
              placeholder="Tháng"
              :clearButton="true"
            ></datepicker>
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div></div>
      <div class="card-body p-10">
        <table>
          <tr>
            <th>TPV T (B)</th>
            <td>{{ dataTotal.totalTpvT | transformMoney }}</td>
          </tr>
          <tr>
            <th>TB T-2 & T-1 (A)</th>
            <td>{{ dataTotal.totalAverageT1T2 | transformMoney }}</td>
          </tr>
          <tr>
            <th>TPV T-1</th>
            <td>{{ dataTotal.totalTpvT1 | transformMoney }}</td>
          </tr>
          <tr>
            <th>TPV T-2</th>
            <td>{{ dataTotal.totalTpvT2 | transformMoney }}</td>
          </tr>
          <tr>
            <th>Thay đổi ( B - A )</th>
            <td>{{ dataTotal.totalDifference | transformMoney }}</td>
          </tr>
        </table>
        <div class="tab-content" id="nav-tabContent">
          <div class="mt-2">
            Số Merchant:
            <strong class="text-primary">{{ pagination.total | transformMoney }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #head(tpvT2)="data">
                {{ data.label }}
                <span
                  class="float-right fonsize-16"
                  style="cursor: pointer"
                  @click="toggleSort('tpv_t2')"
                >
                  <b-icon
                    :icon="search.tpv_t2 == 'ASC' ? 'sort-up' : 'sort-down'"
                    aria-hidden="true"
                  ></b-icon>
                </span>
              </template>
              <template #head(tpvT1)="data">
                {{ data.label }}
                <span
                  class="float-right fonsize-16"
                  style="cursor: pointer"
                  @click="toggleSort('tpv_t1')"
                >
                  <b-icon
                    :icon="search.tpv_t1 == 'ASC' ? 'sort-up' : 'sort-down'"
                    aria-hidden="true"
                  ></b-icon>
                </span>
              </template>
              <template #head(averageT1T2)="data">
                {{ data.label }}
                <span
                  class="float-right fonsize-16"
                  style="cursor: pointer"
                  @click="toggleSort('average_t1_t2')"
                >
                  <b-icon
                    :icon="search.average_t1_t2 == 'ASC' ? 'sort-up' : 'sort-down'"
                    aria-hidden="true"
                  ></b-icon>
                </span>
              </template>
              <template #head(tpvT)="data">
                {{ data.label }}
                <span
                  class="float-right fonsize-16"
                  style="cursor: pointer"
                  @click="toggleSort('tpv_t')"
                >
                  <b-icon
                    :icon="search.tpv_t == 'ASC' ? 'sort-up' : 'sort-down'"
                    aria-hidden="true"
                  ></b-icon>
                </span>
              </template>
              <template #head(difference)="data">
                {{ data.label }}
                <span
                  class="float-right fonsize-16"
                  style="cursor: pointer"
                  @click="toggleSort('difference')"
                >
                  <b-icon
                    :icon="search.difference == 'ASC' ? 'sort-up' : 'sort-down'"
                    aria-hidden="true"
                  ></b-icon>
                </span>
              </template>

              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(merchantEmail)="data">
                <p>{{ data.item.merchantName }}</p>
                <p>{{ data.item.merchantEmail }}</p>
              </template>
              <template #cell(merchantType)="{ item }">
                {{ merchantTypeName(item.merchantType) }}
              </template>
              <template #cell(saleEmail)="data">
                <p>{{ data.item.saleName }}</p>
                <p>{{ data.item.saleEmail }}</p>
              </template>
              <template #cell(tpvT1)="data">
                <div class="text-right">
                  {{ data.item.tpvT1 | transformMoney }}
                </div>
              </template>
              <template #cell(tpvT2)="data">
                <div class="text-right">
                  {{ data.item.tpvT2 | transformMoney }}
                </div>
              </template>
              <template #cell(averageT1T2)="data">
                <div class="text-right">
                  {{ data.item.averageT1T2 | transformMoney }}
                </div>
              </template>
              <template #cell(difference)="data">
                <div class="text-right">
                  {{ data.item.difference | transformMoney }}
                </div>
              </template>
              <template #cell(tpvT)="data">
                <div class="text-right">
                  {{ data.item.tpvT | transformMoney }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            @change="onChangePage"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
    <ModalExportNoti ref="uploadNotif" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { StaffService } from '@/services/staff.service'
  import { DeviceService } from '@/services/device.service'
  import { CommonService } from '@/services/common.service'
  import cloneDeep from 'lodash/cloneDeep'
  import ModalExportNoti from '@/components/ModalExportNoti.vue'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import moment from 'moment'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'merchantEmail', label: 'Merchant', thStyle: 'min-width: 150px' },
    { key: 'merchantType', label: 'Loại merchant', thStyle: 'width: 120px' },
    { key: 'saleEmail', label: 'NV chăm sóc', thStyle: 'min-width: 150px' },
    { key: 'tpvT2', label: 'TPV T-2', thStyle: 'min-width: 150px' },
    { key: 'tpvT1', label: 'TPV T-1', thStyle: 'min-width: 150px' },
    { key: 'averageT1T2', label: 'TB T-2 & T-1 (A)', thStyle: 'min-width: 150px' },
    { key: 'tpvT', label: 'TPV T (B)', thStyle: 'min-width: 150px' },
    { key: 'difference', label: 'Thay đổi (B - A) ', thStyle: 'min-width: 150px' },
  ]

  export default {
    name: 'list-tpv',
    components: { ModalExportNoti },
    data() {
      return {
        Config,
        vi,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataTypeCode: [],
        search: {
          limit: 20,
          page: 1,
          tpv_t2: 'ASC',
          tpv_t1: 'ASC',
          average_t1_t2: 'ASC',
          tpv_t: 'ASC',
          difference: 'ASC',
          sortResultList: [],
        },
        pagination: {
          total: 0,
        },
        listUser: [],
        userId: JSON.parse(localStorage.getItem('userData')).userId,
        dataTotal: {},
        optionMerchantType: [
          { id: 'MC_KEY', text: 'Merchant key' },
          { id: 'MC_NORMAL', text: 'Merchant thường' },
        ],
      }
    },
    watch: {},
    created() {
      this.fetchData()
      this.getListStaffBySuperior()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      merchantTypeName: () => {
        const mapTypeName = {
          MC_KEY: 'Merchant key',
          MC_NORMAL: 'Merchant thường',
        }

        return type => {
          return mapTypeName[type] || type
        }
      },
    },
    methods: {
      async fetchData() {
        try {
          this.tbLoading = true
          // const params = this.search
          const params = this.preareData()
          const response = await DeviceService.getListTPVMerchant(params)
          if (response.code === 1000) {
            this.dataTotal = response.data
            this.lists = response.data.tpvSaleRes
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
          tpv_t2: 'ASC',
          tpv_t1: 'ASC',
          average_t1_t2: 'ASC',
          tpv_t: 'ASC',
          difference: 'ASC',
          sortResultList: [],
        }
        this.fetchData()
      },
      async getListStaffBySuperior() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: this.userId,
          })
          if (data.data.length > 0) {
            this.listUser = data.data.map(e => {
              return {
                id: e.userName,
                text: `${e.name} - ${e.userName}`,
              }
            })
            this.listUser.unshift({ id: 0, text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      // xuất Excel
      async exportExcel() {
        try {
          this.showLoading = true
          // const params = this.prepareData()
          const params = cloneDeep(this.search)
          delete params.page
          delete params.limit
          const body = {
            object: params,
            type: 'CNPS_SUMMARY_TPV_MERCHANT',
          }
          const data = await CommonService.receiveFile(body)
          if (data.success) {
            this.openModalLoadFile(data.data.id)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
      openModalLoadFile(id) {
        this.$refs.uploadNotif.triggerNotification(id)
      },
      toggleSort(field) {
        const sortFields = ['tpv_t2', 'tpv_t1', 'average_t1_t2', 'tpv_t', 'difference']

        sortFields.map(item => {
          if (item != field) {
            this.search[item] = 'ASC'
          }
        })

        this.search[field] = this.search[field] == 'ASC' ? 'DESC' : 'ASC'

        this.search.sortResultList = [{ field: field, direction: this.search[field] }]

        this.fetchData()
      },
      preareData() {
        const data = cloneDeep(this.search)

        if (data.month && data.month != '') {
          data.month = moment(data.month).format('YYMM')
        }

        delete data.tpv_t2
        delete data.tpv_t1
        delete data.average_t1_t2
        delete data.tpv_t
        delete data.difference

        return data
      },
      onChangePage(page) {
        this.search.page = page
        this.fetchData()
      },
    },
  }
</script>
<style scoped>
  table {
    min-width: 20%;
    border-collapse: collapse;
  }

  th {
    font-weight: bold;
    text-align: left;
    padding: 8px;
    background-color: #f2f2f2;
    /* Màu nền của nhãn */
    color: #333;
    /* Màu chữ của nhãn */
    border-bottom: 1px solid #ddd;
    border-top: 1px solid #ddd;
    width: 40%;
  }

  td {
    padding: 8px;
    text-align: right;
    border-bottom: 1px solid #ddd;
  }

  .form_fix input {
    border-radius: 4px;
    border-color: #ced4da;
  }
  .form_fix input::placeholder {
    color: #999999 !important;
  }
</style>
